// import _ from 'lodash';
import dynamic from 'next/dynamic';
import { NextPage } from 'next';
import { IArticle } from 'src/interface/section';
import { IDataLayerGlobal } from 'src/interface/data-layer';
import { IMAGE_SIZE } from 'src/components/image';
import styled from '@emotion/styled';
import useResponsive from 'src/utils/devices';
import _ from 'lodash';

const CardHNoImage = dynamic(import('src/components/cards/card-h-no-img'));
const CardH = dynamic(import('src/components/cards/card-h'));

type Props = {
    className?: string;
    lastNews?: IArticle[];
    heading?: string;
    eventDataLayer?: IDataLayerGlobal;
    path?: string;
    external?: boolean;
    size?: any;
    showImage?: boolean;
    carousel?: boolean;
    bgColor?: string;
    publishedAtKey?: 'published_at' | 'updated_at';
    target?: string;
};

const WidgetNewsVideoGallery: NextPage<Props> = ({ target = '', eventDataLayer, external = false, showImage = false, bgColor = null, lastNews }) => {
    if (_.isEmpty(lastNews)) return null;

    const responsive = useResponsive();
    return (
        <WidgetWrapper className='widget-news' bgColor={bgColor}>
            {responsive.isLaptop && (
                <div className='desktop'>
                    <div className='card-list'>
                        {lastNews?.map((item: any, index: any) => (
                            <div key={index} className='card-item'>
                                {showImage && (
                                    <CardH
                                        className='card-lastnews'
                                        data={item}
                                        target={target}
                                        size={IMAGE_SIZE.MD}
                                        showBlurb={false}
                                        showCountView={false}
                                        external={external}
                                        showVideoIcon={true}
                                        // ! DATALAYER
                                        eventDataLayer={{
                                            ...eventDataLayer,
                                            data: {
                                                title: item?.title,
                                                index: index + 1,
                                                ...eventDataLayer?.data
                                            }
                                        }}
                                    />
                                )}
                                {!showImage && (
                                    <CardHNoImage
                                        className='card-lastnews'
                                        data={item}
                                        size={IMAGE_SIZE.MD}
                                        showBlurb={false}
                                        external={external}
                                        // ! DATALAYER
                                        eventDataLayer={{
                                            ...eventDataLayer,
                                            data: {
                                                title: item?.title,
                                                index: index + 1,
                                                ...eventDataLayer?.data
                                            }
                                        }}
                                    />
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            )}
            {responsive.isMobile && (
                <>
                    <div className='mobile'>
                        <div className='card-list'>
                            {lastNews?.map((item: any, index: any) => (
                                <div key={index} className='card-item'>
                                    {showImage && (
                                        <CardH
                                            className='card-lastnews'
                                            data={item}
                                            target={target}
                                            size={IMAGE_SIZE.MD}
                                            showBlurb={false}
                                            external={external}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                ...eventDataLayer,
                                                data: {
                                                    title: item?.title,
                                                    index: index + 1,
                                                    ...eventDataLayer?.data
                                                }
                                            }}
                                        />
                                    )}
                                    {!showImage && (
                                        <CardHNoImage
                                            className='card-lastnews'
                                            data={item}
                                            size={IMAGE_SIZE.MD}
                                            showBlurb={false}
                                            external={external}
                                            // ! DATALAYER
                                            eventDataLayer={{
                                                ...eventDataLayer,
                                                data: {
                                                    title: item?.title,
                                                    index: index + 1,
                                                    ...eventDataLayer?.data
                                                }
                                            }}
                                        />
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            )}
        </WidgetWrapper>
    );
};

export default WidgetNewsVideoGallery;

const WidgetWrapper = styled.div<{
    bgColor?: string | null;
}>`
  background-color: ${({ bgColor }) => bgColor || '#fff'};
  position: relative;
  overflow: hidden;
  .card-list {
    background-color: rgba(230,230,230,0.75);
    display: grid;
    .card-item {
        padding-top: 4px;
        .card-lastnews{
            border: none;
        }
        .card-h-href{
            align-items: center;
        }
        .card-detail{
            /* padding: 4px; */
            .title{
                font-size: 14px;
                -webkit-line-clamp: 3;
            }
        }
      }
    @media (max-width: 690px) {
      display: block;
      .card-item {
        padding-bottom: 10px;
        .card-lastnews{
            border: none;
        }
      }
    }
  }
  .section-header {
    margin-bottom: 0;
  }
  .card-item {
    .card-h-img {
      .header h3 {
        font-weight: 300;
        -webkit-line-clamp: 3;
      }
    }
  }
`;
